// frontend/src/components/common/LoadingState.tsx
// Text-based loading row. Shared across pages so every "Loading..." looks the same.

import React from "react";

interface LoadingStateProps {
  /** Text to show. Keep it short: "Loading paycheques...", "Loading payments..." */
  message: string;
  /** Vertical/horizontal padding around the message. Defaults to "48px 20px". */
  padding?: string | number;
  /** Font size in px. Defaults to 14. */
  fontSize?: number;
  /** Text color. Defaults to the ink/slate color used across Novala pages. */
  color?: string;
}

export default function LoadingState({
  message,
  padding = "48px 20px",
  fontSize = 14,
  color = "#12262B",
}: LoadingStateProps): React.ReactElement {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        padding,
        textAlign: "center",
        color,
        fontSize,
      }}
    >
      {message}
    </div>
  );
}